import React from 'react';
import { I18n } from '@fiverr-private/i18n-react';
import { AffiliatesLink } from './AffiliatesLink';

interface BlogProps {
  variant: 'footer' | 'header';
}

export const Blog = ({ variant }: BlogProps) => (
  <AffiliatesLink variant={variant} path="/blog" category={'Blog'}>
    <I18n k="affiliates_signup_perseus.blog" />
  </AffiliatesLink>
);
